var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"target":"__blank","href":_vm.dataField['link']}},[_c('img',{class:_vm.dataField['class'],style:(_vm.dataField['style']),attrs:{"src":_vm.dataField['src']}})])])}
var staticRenderFns = []

export { render, staticRenderFns }